<template>
  <!-- 小学入学体检报告 -->
  <div v-if="model && model.primaryEnrolment">
    <div id="print_primaryEnrolment" class="page primaryEnrolment-page">
      <div style="display: flex;font-size: 23px;text-align: center;font-weight: 600;">
        <table style="width: 100%;border-collapse: collapse;border:none;letter-spacing: 5px;">
          <tbody>
          <tr style="width: 100%;border-collapse: collapse;border:none;">
            <td style="border-collapse: collapse;border:none;">{{ model.primaryEnrolment.hospitalName ? model.primaryEnrolment.hospitalName : "" }}</td>
          </tr>
          <tr style="width: 100%;border-collapse: collapse;border:none;">
            <td style="border-collapse: collapse;border:none;">{{ model.primaryEnrolment.reportName ? model.primaryEnrolment.reportName : "小学入学健康检查表" }}</td>
          </tr>
          </tbody>
        </table>
        <div>
          <div>
            <img :src="model.primaryEnrolment.barCodeImage" style="width: 100%; height: 100%;"/>
          </div>
          <div style="line-height: 0px;font-size: 15px;letter-spacing: 0px;" v-if="model.primaryEnrolment.barCodeImage">{{model.primaryEnrolment.barCode}}</div>
        </div>
      </div>

      <table style="padding-left: 10px;text-align: left;width: 100%;margin-top:10px;border-collapse: collapse;border:none;">
        <tbody>
          <tr style="line-height: 40px;border:none;margin-top: 10px;">
            <td colspan="2" style="width: 25%;border:none;margin-top: 10px;">编号： <span>{{ model.primaryEnrolment.healthCareNumber ? model.primaryEnrolment.healthCareNumber : "" }}</span></td>
            <td colspan="5" style="width: 45%;border:none;margin-top: 10px;">学校：<span>{{ model.primaryEnrolment.schoolName ? model.primaryEnrolment.schoolName : "" }}</span></td>
            <td colspan="3" style="width: 30%;border:none;margin-top: 10px;">班级：<span>{{ model.primaryEnrolment.className ? model.primaryEnrolment.className : "" }}</span></td>
          </tr>
        </tbody>
      </table>

      <table style="text-align: center;width: 100%;border-collapse: collapse;border: 1px solid black;">
        <tbody>
          <tr style="line-height: 40px;">
            <td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">姓名</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.name ? model.primaryEnrolment.name : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">性别</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.sex ? model.primaryEnrolment.sex : "" }}</span></td>
            <td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">出生日期</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.birthday ? model.primaryEnrolment.birthday : "" }}</span></td>
          </tr>
          <tr style="line-height: 40px;">
            <td rowspan="2" colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">既往病史</td>
            <td colspan="9" style="width: 100px;border-collapse: collapse;border: 1px solid black;">
              <span :class="{'pastMedicalHistory' : model.primaryEnrolment.pastMedicalHistory && model.primaryEnrolment.pastMedicalHistory.indexOf('1') > -1 }">先天性心脏病&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span :class="{'pastMedicalHistory' : model.primaryEnrolment.pastMedicalHistory && model.primaryEnrolment.pastMedicalHistory.indexOf('2') > -1 }">癫痫&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span :class="{'pastMedicalHistory' : model.primaryEnrolment.pastMedicalHistory && model.primaryEnrolment.pastMedicalHistory.indexOf('3') > -1 }">高热惊厥&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span :class="{'pastMedicalHistory' : model.primaryEnrolment.pastMedicalHistory && model.primaryEnrolment.pastMedicalHistory.indexOf('4') > -1 }">哮喘&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span :class="{'pastMedicalHistory' : model.primaryEnrolment.pastMedicalHistory && model.primaryEnrolment.pastMedicalHistory.indexOf('5') > -1 }">G-6PD缺陷病</span>
            </td>
          </tr>
          <tr style="line-height: 40px;">
            <td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">其他疾病</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.pastMedicalHistoryOther ? model.primaryEnrolment.pastMedicalHistoryOther : "" }}</span></td>
            <td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">过敏史</td><td colspan="3" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.allergyHistory ? model.primaryEnrolment.allergyHistory : "" }}</span></td>
          </tr>
          <tr style="line-height: 40px;">
            <td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">近期传染病接触史</td><td colspan="3" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.infectionHistory ? model.primaryEnrolment.infectionHistory : "" }}</span></td>
            <td colspan="3" style="width: 100px;border-collapse: collapse;border: 1px solid black;">儿童家长签字</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.parentConfirmSignature ? model.primaryEnrolment.parentConfirmSignature : "" }}</span></td>
          </tr>
          <tr style="line-height: 40px;">
            <td rowspan="7" style="width: 100px;border-collapse: collapse;border: 1px solid black;">体格<br/>检查</td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">体重</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.weight ? model.primaryEnrolment.weight : "" }}</span></td><td>评价</td><td><span>{{ model.primaryEnrolment.weightEvaluation ? model.primaryEnrolment.weightEvaluation : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">身高</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.height ? model.primaryEnrolment.height : "" }}</span></td><td>评价</td><td><span>{{ model.primaryEnrolment.heightEvaluation ? model.primaryEnrolment.heightEvaluation : "" }}</span></td>
          </tr>
          <tr style="line-height: 40px;">
            <td rowspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">眼</td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">左眼</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.nakedLeftEyeVision ? model.primaryEnrolment.nakedLeftEyeVision : "" }}</span></td>
            <td rowspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">耳</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;">左耳</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.leftEar ? model.primaryEnrolment.leftEar : "" }}</span></td>
            <td rowspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">口腔</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;">牙齿数</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.teethNumber ? model.primaryEnrolment.teethNumber : "" }}</span></td>
          </tr>
          <tr style="line-height: 40px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">右眼</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.nakedRightEyeVision ? model.primaryEnrolment.nakedRightEyeVision : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">右耳</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.rightEar ? model.primaryEnrolment.rightEar : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">龋齿数</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.cariesTotalNumber ? model.primaryEnrolment.cariesTotalNumber : "" }}</span></td>
          </tr>
          <tr style="line-height: 40px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">头颅</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.head ? model.primaryEnrolment.head : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">胸廓</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.thorax ? model.primaryEnrolment.thorax : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">脊柱&四肢</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.spineLimbs ? model.primaryEnrolment.spineLimbs : "" }}</span></td>
          </tr>
          <tr style="line-height: 40px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">心肺</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.heart ? model.primaryEnrolment.heart : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">肝脾</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.liverAndSpleen ? model.primaryEnrolment.liverAndSpleen : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">外生殖器</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.externalGenitalia ? model.primaryEnrolment.externalGenitalia : "" }}</span></td>
          </tr>
          <tr style="line-height: 40px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">皮肤</td><td colspan="5" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.skin ? model.primaryEnrolment.skin : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">咽部</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.pharynx ? model.primaryEnrolment.pharynx : "" }}</span></td>
          </tr>
          <tr style="line-height: 40px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">其他</td><td colspan="8" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.otherPhysicalExamination ? model.primaryEnrolment.otherPhysicalExamination : "" }}</span></td>
          </tr>
          <tr style="line-height: 40px;">
            <td rowspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">辅助<br/>检查</td>
            <td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">血红蛋白</td><td colspan="3" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.hemoglobinValue ? model.primaryEnrolment.hemoglobinValue : "" }}</span></td>
            <td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">丙氨酸氨基转移酶</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.alanineAminotransferase ? model.primaryEnrolment.alanineAminotransferase : "" }}</span></td>
          </tr>
          <tr style="line-height: 40px;">
            <td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">其他</td><td colspan="7" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.otherAuxiliaryInspection ? model.primaryEnrolment.otherAuxiliaryInspection : "" }}</span></td>
          </tr>
          <tr style="line-height: 40px;">
            <td colspan="3" style="width: 100px;border-collapse: collapse;border: 1px solid black;">检查结果</td><td colspan="7" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.inspectionResults ? model.primaryEnrolment.inspectionResults : "" }}</span></td>
          </tr>
          <tr style="line-height: 40px;">
            <td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">检查单位盖章</td><td colspan="2" style="height: 80px;border-collapse: collapse;border: 1px solid black;"><img :src="model.primaryEnrolment.sealOfInspectionUnit" style="height: 40px;width: 100px;object-fit: contain;" v-if="model.primaryEnrolment.sealOfInspectionUnit"></td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">医师签名</td><td colspan="2" style="height: 80px;border-collapse: collapse;border: 1px solid black;"><img :src="model.primaryEnrolment.doctorSignature" style="height: 40px;width: 100px;object-fit: contain;" v-if="model.primaryEnrolment.doctorSignature"></td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">体检日期</td><td colspan="2" style="height: 80px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.physicalDate ? model.primaryEnrolment.physicalDate : "" }}</span></td>
          </tr>
          <tr style="line-height: 40px;" v-if="model.primaryEnrolment.remark">
            <td colspan="10" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.primaryEnrolment.remark ? model.primaryEnrolment.remark : "" }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>

import {_primaryEnrolment} from "@/services/report/report";
export default {
  name: "primaryEnrolmentReport",
  props: {
    physicalId:[String,Number],
    barCode:[String,Number],
    reportCode: [String],
    printData: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      model: {
        primaryEnrolment:{
          reportName: "",
          hospitalName: "",
          name: "",
        }
      },
    };
  },
  watch:{
    reportCode:{
      handler(newVal,oldVal){
        if(newVal === 'primaryEnrolment'){
          this.loadData();
        }
      }
    },
    printData: {
      handler(newVal) {
        if (newVal && this.reportCode === 'primaryEnrolment') {
          this.model = newVal;
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  onLoad() {
    console.log("onLoad")
  },
  onUnLoad(){
    console.log("onUnLoad")
  },
  onReady () {
    console.log("onReady")
  },
  methods: {
    loadData(){
      if(this.barCode){
        this.primaryEnrolment(this.barCode);
      }
    },
    primaryEnrolment(barCode) {
      _primaryEnrolment({barCode: barCode}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.$emit('on-setReportData', res.data);
        this.model = res.data;
        /*if(this.model.primaryEnrolment.barCodeImage){
          this.drawBase64ToCanvas(this.model.primaryEnrolment.barCodeImage);
        }*/
      })
    },
    drawBase64ToCanvas (base64String) {
      const canvas = this.$refs.barcodeImage;
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        // 设置Canvas尺寸与图片一致
        canvas.width = img.width;
        canvas.height = img.height;
        // 绘制图片
        ctx.drawImage(img, 0, 0);
      };

      img.onerror = () => console.error("图片加载失败");
      img.src = base64String;
    }
  }
}
</script>

<style lang="postcss" scoped>
@media print {
  .primaryEnrolment-page {
    page: primaryEnrolment-page; /* 绑定唯一命名 */
  }
  @page primaryEnrolment-page {size: A4;margin: 0;}
  body {width: 210mm;height: 297mm;margin: 0 auto;background: white;}
  .no-print { display: none; } /* 隐藏非打印元素 */
}
.page {width: 210mm;height: 297mm;margin:0 auto;padding-top:30px;padding-left:25px;padding-right:25px;overflow: hidden;position: relative;PAGE-BREAK-AFTER: always;background: #fff; font-size: 15px;}
.pastMedicalHistory::before{content: '√';color: red;position: relative;left: 15px;top: 5px;font-weight: 600;font-size: 20px;line-height: 24px;}

</style>

